import { render, staticRenderFns } from "./NumberListMultiValue.vue?vue&type=template&id=45fdbd89"
import script from "./NumberListMultiValue.vue?vue&type=script&lang=ts"
export * from "./NumberListMultiValue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports